import React from 'react';
export default function SpacesForRequiredFields(e) {
    if (e.target.value && e.target.value.trim() === '') {
        return null;
    }

    return e.target.value;
}
